export default "__VITE_ASSET__f77fa710__"